module.exports = __webpack_public_path__ + "media/images/lb/883-b9e6d4d65fb510772f7816f24aa58a6a.svg";